import React from 'react';
import ReactDOM from 'react-dom/client';
import { DashboardLayout } from './components/DashboardLayout';
import FrontDesk from './FrontComponent/FrontDesk';
import Guest from './components/Guest';
import Inventory from './components/Inventory';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import Room from './components/Room';
import Roomorder from './components/RoomOrder/Roomorder';
import Deal from './components/Deal';
import Rate from './components/Rate';
import Booking from './components/Booking';
import Document from './components/Document';
import Invoices from './components/Invoices/Invoices';
import LoginPage from './components/pages/LoginPage';
import PrivateRoute from './routes/PrivateRoute';
import UnauthorizedPage from './pages/UnauthorizedPage';
import HotelDetails from './pages/HotelDetails';

export const DashboardIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 13H10C10.55 13 11 12.55 11 12V4C11 3.45 10.55 3 10 3H4C3.45 3 3 3.45 3 4V12C3 12.55 3.45 13 4 13ZM4 21H10C10.55 21 11 20.55 11 20V16C11 15.45 10.55 15 10 15H4C3.45 15 3 15.45 3 16V20C3 20.55 3.45 21 4 21ZM14 21H20C20.55 21 21 20.55 21 20V12C21 11.45 20.55 11 20 11H14C13.45 11 13 11.45 13 12V20C13 20.55 13.45 21 14 21ZM13 4V8C13 8.55 13.45 9 14 9H20C20.55 9 21 8.55 21 8V4C21 3.45 20.55 3 20 3H14C13.45 3 13 3.45 13 4Z"
      fill="currentColor"
    />
  </svg>
);

export const FrontDeskIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 20H22V16H2V20ZM4 17H6V19H4V17ZM2 4V8H22V4H2ZM6 7H4V5H6V7ZM2 14H22V10H2V14ZM4 11H6V13H4V11Z"
      fill="currentColor"
    />
  </svg>
);

export const GuestIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z"
      fill="currentColor"
    />
  </svg>
);

export const RoomsIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 19V4H5V19H3V20H21V19H19ZM7 19V6H17V19H7Z"
      fill="currentColor"
    />
    <path
      d="M9 8H15V10H9V8ZM9 11H15V13H9V11ZM9 14H13V16H9V14Z"
      fill="currentColor"
    />
  </svg>
);

export const DealIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.41 11.58L12.41 2.58C12.05 2.22 11.55 2 11 2H4C2.9 2 2 2.9 2 4V11C2 11.55 2.22 12.05 2.59 12.42L11.59 21.42C11.95 21.78 12.45 22 13 22C13.55 22 14.05 21.78 14.41 21.41L21.41 14.41C21.78 14.05 22 13.55 22 13C22 12.45 21.77 11.94 21.41 11.58ZM13 20.01L4 11V4H11V3.99L20 12.99L13 20.01Z"
      fill="currentColor"
    />
    <path
      d="M6.5 8C7.32843 8 8 7.32843 8 6.5C8 5.67157 7.32843 5 6.5 5C5.67157 5 5 5.67157 5 6.5C5 7.32843 5.67157 8 6.5 8Z"
      fill="currentColor"
    />
  </svg>
);

export const RateIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z"
      fill="currentColor"
    />
  </svg>
);

export const SearchIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z"
      fill="currentColor"
    />
  </svg>
);

export const NotificationIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.9 22 12 22ZM18 16V11C18 7.93 16.37 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.64 5.36 6 7.92 6 11V16L4 18V19H20V18L18 16ZM16 17H8V11C8 8.52 9.51 6.5 12 6.5C14.49 6.5 16 8.52 16 11V17Z"
      fill="currentColor"
    />
  </svg>
);

export const MoreIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM12 16C10.9 16 10 16.9 10 18C10 19.1 10.9 20 12 20C13.1 20 14 19.1 14 18C14 16.9 13.1 16 12 16Z"
      fill="currentColor"
    />
  </svg>
);

export const CalendarIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3.01 3.9 3.01 5L3 19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V8H19V19ZM7 10H12V15H7V10Z"
      fill="currentColor"
    />
  </svg>
);

export const NovotelLogo = () => (
  <svg
    width="30"
    height="40"
    viewBox="0 0 30 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15 0L30 10V30L15 40L0 30V10L15 0Z" fill="#1366D9" />
    <path d="M15 8L22 12V24L15 28L8 24V12L15 8Z" fill="white" />
  </svg>
);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <Routes>
      <Route exact path="/" element={<LoginPage />} />
      <Route path="/unauthorized" element={<UnauthorizedPage />} />

      <Route
        path="/dashboard"
        element={
          <PrivateRoute allowedRoles={['manager', 'housekeeping']}>
            <DashboardLayout />
          </PrivateRoute>
        }
      />

      <Route
        path="/hotel-details"
        element={
          <PrivateRoute allowedRoles={['manager']}>
            <HotelDetails />
          </PrivateRoute>
        }
      />

      <Route
        path="/guest"
        element={
          <PrivateRoute allowedRoles={['manager']}>
            <Guest />
          </PrivateRoute>
        }
      />
      <Route
        path="/inventory"
        element={
          <PrivateRoute allowedRoles={['manager']}>
            <Inventory />
          </PrivateRoute>
        }
      />
      <Route
        path="/room"
        element={
          <PrivateRoute allowedRoles={['manager', 'housekeeping']}>
            <Room />
          </PrivateRoute>
        }
      />
      <Route
        path="/room-orders"
        element={
          <PrivateRoute allowedRoles={['manager']}>
            <Roomorder />
          </PrivateRoute>
        }
      />
      <Route
        path="/frontdesk"
        element={
          <PrivateRoute allowedRoles={['manager']}>
            <FrontDesk />
          </PrivateRoute>
        }
      />
      <Route
        path="/booking"
        element={
          <PrivateRoute allowedRoles={['manager']}>
            <Booking />
          </PrivateRoute>
        }
      />
      <Route
        path="/deal"
        element={
          <PrivateRoute allowedRoles={['manager']}>
            <Deal />
          </PrivateRoute>
        }
      />
      <Route
        path="/rate"
        element={
          <PrivateRoute allowedRoles={['manager']}>
            <Rate />
          </PrivateRoute>
        }
      />
      <Route
        path="/documents"
        element={
          <PrivateRoute allowedRoles={['manager']}>
            <Document />
          </PrivateRoute>
        }
      />
      <Route
        path="/invoices"
        element={
          <PrivateRoute allowedRoles={['manager']}>
            <Invoices />
          </PrivateRoute>
        }
      />
    </Routes>
  </BrowserRouter>
);
